import { Box } from "@mui/material";

export const Separator = () => <Box pt="1em" />;
